var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99769 4.95602L2.01134 0.963971L2.01137 0.963943L2.00813 0.960813C1.71714 0.679729 1.25795 0.679729 0.966966 0.960813L0.966864 0.960706L0.960892 0.966886C0.681349 1.25613 0.677056 1.72424 0.963894 2.01102C0.963897 2.01102 0.9639 2.01102 0.963903 2.01102L4.95032 5.99686L0.964109 9.98877C0.964047 9.98883 0.963984 9.98889 0.963922 9.98896C0.676875 10.2755 0.681521 10.744 0.960891 11.0331L0.960785 11.0332L0.966966 11.0392C1.25795 11.3203 1.71714 11.3203 2.00813 11.0392L2.00815 11.0392L2.01134 11.036L5.99769 7.04398L9.99068 11.036L5.99769 4.95602ZM5.99769 4.95602L9.99089 0.963823C10.2759 0.67884 10.7465 0.678543 11.0314 0.964029L10.8544 1.14062L11.0312 0.963823C11.3205 1.25309 11.3258 1.72515 11.0297 2.01247L7.04476 5.99686L11.0299 9.98768C11.3257 10.2753 11.3207 10.7468 11.0312 11.0362C10.7462 11.3211 10.2758 11.3215 9.99089 11.0362L5.99769 4.95602Z",
    fill: "#3CB4E5",
    stroke: "#3CB4E5",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/Cross.ec34181d13597f37976aa265546d93c9.svg";
export { ForwardRef as ReactComponent };